function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.412 22.683l-2.52-1.7h0l-2.75-1.855-4.736 1.261-.204-.251a10.809 10.809 0 01-.302-.397 23.904 23.904 0 01-2.476-4.324c-.575-1.31-.894-2.531-1.016-3.63-.067-.596-.064-1.032-.037-1.281l.027-.258 4.212-2.33a18099.685 18099.685 0 01.114-.86c.112-.831.225-1.664.333-2.442l.014-.097c.19-1.362.342-2.397.443-2.984a.808.808 0 00-.012-.278 122.73 122.73 0 01-3.213-.34L7.185.903A569.15 569.15 0 015.743.736L4.5.59l-.848-.1-.067.086A14.463 14.463 0 001.357 4.65c-1.284 3.63-1.2 7.778.823 12.446 2.029 4.68 4.833 7.847 8.047 9.755 1.994 1.184 4.25 1.805 4.655 1.702.046-.012 2.626-3.35 4.5-5.864.017-.022.025-.02.032-.013zM3.807-.287l-.034-.089c-.2-.141-.2-.141-.226-.14.12.102.203.173.26.23zM2.96-.25s0 0 0 0c.018-.025.018-.025.008-.008-.015.024-.015.024-.047.124l-.005.038a.244.244 0 01.044-.154zm-.044.154c-.02.141-.02.197.087.306a1.104 1.104 0 01-.087-.306z",
  "data-svg-class": "PhoneIcon-stroke",
  stroke: "#979797",
  fill: "none",
  fillRule: "evenodd"
});

function SvgInputStandardPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 30,
    viewBox: "0 0 20 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputStandardPhone);
export default __webpack_public_path__ + "static/media/InputStandardPhone.84f51f21.svg";
export { ForwardRef as ReactComponent };